import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FaSave } from 'react-icons/fa';

const AdminCreateCustomer = () => {
  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('adminToken');
  const navigate = useNavigate();

  const handleCreate = async () => {
    setLoading(true);
    try {
      await axios.post(
        '/api/admin/customers',
        { name, phoneNumber, email },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      navigate('/admin/customers');
    } catch (error) {
      console.error('Error creating customer:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1 className='text-3xl font-bold mb-8'>Create Customer</h1>
      <div className='space-y-4'>
        <div>
          <label className='block mb-2 font-semibold'>Customer Name</label>
          <input
            type='text'
            className='w-full p-3 border rounded'
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder='Enter customer name'
          />
        </div>
        <div>
          <label className='block mb-2 font-semibold'>Phone Number</label>
          <input
            type='text'
            className='w-full p-3 border rounded'
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            placeholder='Enter phone number'
          />
        </div>
        <div>
          <label className='block mb-2 font-semibold'>Email</label>
          <input
            type='email'
            className='w-full p-3 border rounded'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder='Enter email'
          />
        </div>
        <button
          onClick={handleCreate}
          className='inline-block bg-blue-500 text-white py-2 px-4 rounded'
          disabled={loading}
        >
          <FaSave className='mr-2 inline' /> {loading ? 'Saving...' : 'Save'}
        </button>
      </div>
    </div>
  );
};

export default AdminCreateCustomer;
